import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-avatarselector',
  templateUrl: './avatarselector.component.html',
  styleUrls: ['./avatarselector.component.scss']
})
export class AvatarselectorComponent {

  avatars: number[] = new Array(20).fill(1).map((v, i) => i + 1);

  constructor(
    private ref: DynamicDialogRef
  ) { }

  select(avatar: number): void {
    this.close(avatar);
  }

  close(avatar: number): void {
    this.ref.close(avatar);
  }

}
